/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Gate_DismissInputs */

const en_common_auth_gate_dismiss = /** @type {(inputs: Common_Auth_Gate_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not now`)
};

const zh_common_auth_gate_dismiss = /** @type {(inputs: Common_Auth_Gate_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂不需要`)
};

/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Common_Auth_Gate_DismissInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_gate_dismiss = /** @type {((inputs?: Common_Auth_Gate_DismissInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Gate_DismissInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_gate_dismiss(inputs)
	return zh_common_auth_gate_dismiss(inputs)
});
export { common_auth_gate_dismiss as "common.auth.gate.dismiss" }